export const initialProd = {
  brand: "",
  notificationNo: "",
  name: "",
  shortName: "",
  image: "",
  nameVi: "",
  manufacturer: "",
  vat: "",
  description: "",
  unit: "",
  shelfLife: "",
  productModels: [
    {
      name: "",
      barcode: "",
      image: "",
      price: "",
      code: "",
      vat: "",
      shippingInfo: {
        weight: "",
        length: "",
        width: "",
        height: "",
      },
    },
  ],
};